

export class UserVO{
    private id: number;
    private emailId: string;
    private firstName: string;
    private lastName: string;
    private username: string;
    private phoneMobile: string;
    private phoneLandline: string;
    private dateOfBirth: Date;

    constructor(userVO?: any){
        if(userVO!==undefined){
            this.emailId = (userVO.body.emailId);
            this.firstName = (userVO.body.firstName);
            this.lastName = (userVO.body.lastName);
            this.username = (userVO.body.username);
            this.phoneMobile = (userVO.body.phoneMobile);
            this.phoneLandline = (userVO.body.phoneLandline);
            this.dateOfBirth = (userVO.body.dateOfBirth);    
        }
    }
    public getId():number{
        return this.id;
    }

    public getEmailId():string{
        return this.emailId;
    }

    public getFirstName():string{
        return this.firstName;
    }

    public getLastname():string{
        return this.lastName;
    }
    
    public getUsername():string{
        return this.username;
    }

    public getPhoneMobile():string{
        return this.phoneMobile;
    }

    public getPhoneLandline():string{
        return this.phoneLandline;
    }

    public getDOB(): Date{
        return this.dateOfBirth;
    }

    public setId(id: number): void{
        this.id = id;
    }

    public setEmailId(emailId: string): void{
        this.emailId = emailId;
    }

    public setFirstName(firstName: string): void{
        this.firstName = firstName;
    }

    public setLastName(lastName: string): void{
        this.lastName = lastName;
    }

    public setUsername(username: string): void{
        this.username = username;
    }

    public setPhoneMobile(phoenMobile: string): void{
        this.phoneMobile = phoenMobile;
    }
    
    public setPhoneLandline(phoneLandline: string): void{
        this.phoneLandline = phoneLandline;
    }
    
    public setDOB(dob: Date): void{
        this.dateOfBirth = dob;
    }    

}

export class SsoTokenVO {
    private accessToken: string;
    private refreshToken: string;

    public getAccessToken(): string {
        return this.accessToken;
    }

    public getRefreshToken(): string {
        return this.refreshToken;
    }

    public setAccessToken(accessToken: string): void {
        this.accessToken = accessToken;
    }

    public setRefreshToken(refreshToken: string): void {
        this.refreshToken = refreshToken;
    }
}


// WEBPACK FOOTER //
// ./src/app/sso/sso.models.ts